import styled from "styled-components";

export const TableContainer = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr 1fr 1fr 1fr 1fr;
  gap: 0;
  width: 100%;
`;

export const TableHeader = styled.ul`
  display: contents;
  white-space: nowrap;
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    background-color: rgba(255, 255, 255, 0.15);
    padding: 15px 20px;
    text-align: left;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
  }

  li:first-child {
    border-radius: 5px 0 0 0;
  }

  li:last-child {
    border-radius: 0 5px 0 0;
  }
`;

export const TableBody = styled.div`
  display: contents;
`;

// TBody.jsx
export const TableRow = styled.div`
  display: contents;
  white-space: nowrap;
`;

export const TableCell = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.06);
  }
`;

export const StatusBadge = styled.span`
  padding: 6px 14px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;

  &.approved {
    background: rgba(76, 175, 80, 0.2);
    color: #4caf50;
    border: 1px solid rgba(76, 175, 80, 0.3);
  }

  &.pending,
  &.waiting {
    background: rgba(255, 193, 7, 0.2);
    color: #ffc107;
    border: 1px solid rgba(255, 193, 7, 0.3);
  }

  &.rejected,
  &.withdrawn {
    background: rgba(244, 67, 54, 0.2);
    color: #f44336;
    border: 1px solid rgba(244, 67, 54, 0.3);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
`;

export const Button = styled.button`
  font-size: 15px;
  padding: 6px 20px;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  font-weight: 500;
  transition: all 0.3s;

  &.approve-button {
    background-color: #4caf50;
    color: white;

    &:hover:not(:disabled) {
      background-color: #45a049;
      transform: translateY(-1px);
    }

    &:disabled {
      background-color: #626262;
      color: #333;
      cursor: default;
    }
  }

  &.reject-button {
    background-color: #2f2f2f;
    border: 2px solid #595959;
    color: #fff;

    &:hover:not(:disabled) {
      background-color: #f44336;
      border-color: #f44336;
      transform: translateY(-1px);
    }

    &:disabled {
      background-color: #1d1d1d;
      border: 2px solid #595959;
      color: #696969;
      cursor: default;
    }
  }
`;
